import apiConfig from './api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const signinAdmin = async (credentials) => {
  const { username, password } = credentials;
  if (!username) {
    throw new Error('Email is required');
  }

  if (!password) {
    throw new Error('Password is required');
  }

  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/signin-admin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to sign up');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const sendInvitation = async (email) => {
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/signup-notify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send invitation');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};
